import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import './styles.css'
import { rememberSource } from './attribution'
import { setupAndroidBack } from './platform'
import { currentBack, initTelegram } from './telegram'

// index.html ещё до загрузки решает, что показать: приложение или страницу
// о нём (посетителю сайта из обычного браузера). В режиме страницы приложение
// не запускается вовсе.
if (document.documentElement.dataset.mode !== 'landing') {
  document.getElementById('landing')?.remove()
  initTelegram()
  rememberSource()
  setupAndroidBack(currentBack)

  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}
